const Home = () => import('@/views/Home')
const Jcsystem = () => import('@/views/jcsystem')
const Report = () => import('@/views/report')
const Service = () => import('@/views/service')
const Lwfooter = () => import('@/components/lwfooter')
const Ccpage = () => import('@/views/ccpage')
const Pay = () => import('@/views/pay')
const Login = () => import('@/components/Login')
const Register = () => import('@/components/Register')
const About = () => import('@/views/about')
const Payment = () => import('@/views/Payment')
const Result = () => import('@/views/result')
const Qrimg = () => import('@/views/qrimg')
const QueryOrder =()=>import('@/views/queryOrder')
const Blankpage = () => import('@/views/blankpage')
const Verification = ()=>import('@/views/verification')
const Mycard = ()=>import("@/views/myCard")
const ActiveVip = ()=>import("@/views/activeVip")
const BdWebView = ()=>import("@/views/bdWebView")
const index =()=>import("@/views/index")


export default [
  {
    path: '/',
    redirect: '/home',
    component:index,
    meta: {}
  },
  {
    path: '/home',
    name: 'home',
    components: { default: Home, footer: Lwfooter },
    meta: {
      isTabbar: true,
      title: '首页',
      id: 'home',
      icon: '&#xe640;',
      activeIcon: '&#xe63a;',
      page_title:"首页"
    }
  },
  {
    path: '/qrimg',
    name: 'qrimg',
    component: Qrimg,
    meta: {
      isTabbar: false,
      page_title:"维普查重_二维码页面"
    }
  },
  {
    path: '/jcsystem',
    name: 'jcsystem',
    components: { default: Jcsystem, footer: Lwfooter },
    meta: {
      isTabbar: true,
      title: '检测系统',
      id: 'jcsystem',
      icon: '&#xe607;',
      activeIcon: '&#xe63c;',
      page_title:"维普查重_二维码页面"
    }
  },
  {
    path: '/result',
    name: 'Result',
    component: Result,
    meta: {
      isTabbar: false,
      page_title:"维普查重_二维码页面"
    }

  },
  {
    path: '/report',
    name: 'report',
    components: { default: Report, footer: Lwfooter },
    meta: {
      isTabbar: true,
      title: '查看报告',
      id: 'report',
      icon: '&#xe63f;',
      activeIcon: '&#xe605;',
      page_title:"维普查重_二维码页面"
    }
  },
  {
    path: '/service',
    name: 'service',
    components: { default: Service, footer: Lwfooter },
    meta: {
      isTabbar: true,
      title: '个人中心',
      id: 'service',
      icon: '&#xe634;',
      activeIcon: '&#xe641;',
      page_title:"维普查重_二维码页面"
    }
  },
  {
    path: '/ccpage',
    name: 'ccpage',
    components:
      { default: Ccpage },
    meta: {
      isAuthRequired: true,
      page_title:"维普查重_查重页面"
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay,
    meta: {
      isTabbar: false,
      page_title:"维普查重_支付页面"
    }
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment,
    meta: {
      isTabbar: false,
      page_title:"维普查重_支付结果页面"
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      isTabbar: false,
      page_title:"维普查重_登录页面"
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      isTabbar: false,
      page_title:"维普查重_注册页面"
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      isTabbar: false,
      page_title:"维普查重_关于我们"
    }
  },
  {
    path: "/queryorder",
    name: "queryorder",
    component: QueryOrder,
    meta:{
      isTabbar:false,
      page_title:"维普查重_查询订单页面"
    }
  },
  {
    path:'/blankpage',
    name:'blankpage',
    component:Blankpage,
    meta: {
      isTabbar: false
    }
  },
  {
    path:"/verification",
    name:'verification',
    component:Verification,
    meta: {
      isTabbar: false,
      page_title:"维普查重_验证页面"
    }
  },
  {
    path:"/myCard",
    name:'mycard',
    component:Mycard,
    meta:{
      isTabbar:false
    }
  },
  {
    path:"/active_vip",
    name:"active_vip",
    component:ActiveVip,
    meta:{
      isTabbar:false
    }
  },
  {
    path:"/bd_Web_view",
    name:"bd_Web_view",
    component:BdWebView,
    meta:{
      isTabbar:false
    }
  },
 

]
